"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useIsAdmin } from "@/components/shared/navbar/admin/use-is-admin";
import { usePagesVisibility } from "@/hooks/use-pages-visibility";
import {
	isPageVisibleForUser,
	type ManagedPageKey,
} from "@/types/site-settings";

export default function PageVisibilityGuard({
	pageKey,
	children,
}: {
	pageKey: ManagedPageKey;
	children: React.ReactNode;
}) {
	const router = useRouter();
	const isAdmin = useIsAdmin();
	const { pages, loading } = usePagesVisibility();
	const visible = isPageVisibleForUser(pageKey, pages, isAdmin);

	useEffect(() => {
		if (loading || visible) return;
		router.replace("/");
	}, [loading, visible, router]);

	if (loading) return null;
	if (!visible) return null;

	return <>{children}</>;
}
